import { useMutation } from '@tanstack/react-query';
import { regeneratePartnerCoverBannerFromFile } from '../services/regeneratePartnerMedia';

/** POST /admin/partner/regenerate-cover-banner */
export const useRegeneratePartnerCoverBannerMutation = (options = {}) => {
  return useMutation({
    mutationKey: ['regenerate-partner-cover-banner'],
    mutationFn: ({ file, signal }) => regeneratePartnerCoverBannerFromFile(file, { signal }),
    ...options,
  });
};
